/**
 * ConfirmPasswordConfirmation.jsx
 * Created by michaelbray on 2/13/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from '../../../sharedComponents/icons/Icons';

const propTypes = {
    label: PropTypes.string,
    message: PropTypes.string,
    email: PropTypes.string,
    closeModal: PropTypes.func
};

export default class ConfirmPasswordConfirmation extends React.Component {
    componentDidMount() {
        this.header.focus();
    }

    render() {
        return (
            <div>
                <div
                    className="rec-modal-title"
                    ref={(header) => this.header = header}>
                    {this.props.label}
                </div>
                <div className="rec-acct-modal-media">
                    <Icons.IconCheck />
                </div>
                <p>{this.props.message}</p>
                <p><strong>{this.props.email}</strong></p>
                <button
                    onClick={this.props.closeModal}
                    className="rec-button-primary"
                    title="Close"
                    aria-label="Close">
                    Close
                </button>
            </div>
        );
    }
}

ConfirmPasswordConfirmation.propTypes = propTypes;
